import { DocumentNode, gql } from "@apollo/client";

class FetalSexService {
  public static getFetalSex = (): DocumentNode => gql`
    query GetFetalSexIsShown($orderUidPublic: String!) {
      getFetalSexIsShown(orderUidPublic: $orderUidPublic) {
        fetalSexIsShown
      }
    }
  `;

  public static updateFetalSexIsShown = (): DocumentNode => gql`
    mutation UpdateFetalSexIsShown(
      $orderUidPublic: String!
      $testUid: String!
      $fetalSexIsShown: Boolean!
    ) {
      updateFetalSexIsShown(
        orderUidPublic: $orderUidPublic
        testUid: $testUid
        fetalSexIsShown: $fetalSexIsShown
      ) {
        orderUidPublic
        fetalSexIsShown
        documentUid
      }
    }
  `;
}

export default FetalSexService;
